<template>
	<div class="page">
		<gc-header headerData="batchImportTaskDetail"></gc-header>
		<div class="page-main task-details-main">
			<gc-group-detail :data="basicInfoData">
				<template #failFilePath>
					<p class="download-file-path" @click="handleDownloadFailFile">
						{{ taskDetails ? '下载' : '--' }}
					</p>
				</template>
			</gc-group-detail>
			<div class="task-details-table-show">
				<div class="table-header">设备列表</div>
				<div class="table-box">
					<div class="serach">
						<gc-custom-search
							keyWord="设备通讯编号"
							width="320px"
							:search.sync="form.deviceNo"
						></gc-custom-search>
						<div class="serach-ops">
							<el-button type="primary" @click="handleQuerySearch" v-click-blur>查询</el-button>
							<el-button v-click-blur @click="handleQueryReset">重置</el-button>
						</div>
					</div>
					<gc-table
						v-loading="loading"
						border
						showPage
						:columns="columns"
						:table-data="tableData"
						:current-page.sync="pagination.currentPage"
						:total="pagination.total"
						:pageSize="pagination.pageSize"
						gloabSortDisable
						paginationLayout="prev, next, jumper"
						@current-page-change="handleCurrentPageChange"
					></gc-table>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import {
	apiGetDeviceImeiRegistTaskDetails,
	apiGetDeviceImeiRegistList,
	apiExportFailDetails,
} from '@/apis/communicationModelManage.api'
import {
	batchImportSubTaskStatusOptions,
	MODULE_BATCH_TASK_TYPE_OPTIONS_MAP,
	MODULE_TASK_STATUS_MAP,
} from '@/config/const'
export default {
	name: 'BatchTaskDetails',
	data() {
		return {
			taskId: this.$route.query.taskId,
			batchImportSubTaskStatusOptions,
			form: {
				deviceNo: null,
			},
			columns: [
				{
					key: 'deviceNo',
					name: '设备通讯编号',
					tooltip: true,
				},
				{
					key: 'imei',
					name: 'IMEI',
					tooltip: true,
				},
				{
					key: 'statusName',
					name: '任务状态',
				},
				{
					key: 'errorMessage',
					name: '失败原因',
				},
				{
					key: 'createTime',
					name: '创建时间',
				},
			],
			loading: false,
			pagination: {
				currentPage: 1,
				pageSize: 10,
				total: 0,
			},
			tableData: [],
			taskDetails: null,
		}
	},

	created() {
		this.queryBatchImportTaskDetails()
		this.queryBatchImportSubTaskList()
	},

	methods: {
		/**
		 * 批量任务详情查询
		 */
		async queryBatchImportTaskDetails() {
			const data = await apiGetDeviceImeiRegistTaskDetails(this.taskId)
			this.taskDetails = data
		},

		/**
		 * 批量导入子任务列表数据查询
		 */
		async queryBatchImportSubTaskList() {
			this.loading = true
			const searchParams = {
				...this.form,
				taskId: this.taskId,
				current: this.pagination.currentPage,
				size: this.pagination.pageSize,
			}
			try {
				const { records = [], total } = await apiGetDeviceImeiRegistList(searchParams)
				this.tableData = records
				this.pagination.total = total
			} finally {
				this.loading = false
			}
		},

		/**
		 * 失败任务明细Excel文件下载
		 */
		async handleDownloadFailFile() {
			if (!this.taskDetails?.failureCount) return
			const data = await apiExportFailDetails({ taskId: this.taskDetails.taskId, status: 2 })
			const blob = new Blob([data], { type: 'application/vnd.ms-excel' })
			const link = document.createElement('a')
			link.style.display = 'none'
			link.href = URL.createObjectURL(blob)
			link.download = '任务失败明细'
			document.body.appendChild(link)
			link.click()
			document.body.removeChild(link)
			this.$message.success('下载成功')
		},

		handleCurrentPageChange(current) {
			this.pagination.currentPage = current
			this.queryBatchImportSubTaskList()
		},

		handleQuerySearch() {
			this.pagination.currentPage = 1
			this.queryBatchImportSubTaskList()
		},

		handleQueryReset() {
			this.pagination.currentPage = 1
			for (const key in this.form) {
				this.form[key] = null
			}
			this.queryBatchImportSubTaskList()
		},
	},

	computed: {
		basicInfoData() {
			return {
				title: '任务属性',
				row: 4,
				list: [
					{
						key: 'taskName',
						label: '任务名称',
						value: this.taskDetails?.taskName,
					},
					{
						key: 'deviceGroupName',
						label: '设备组',
						value: this.taskDetails?.deviceGroupName,
					},
					{
						key: 'operationType',
						label: '操作类型',
						value: MODULE_BATCH_TASK_TYPE_OPTIONS_MAP[this.taskDetails?.operationType],
					},
					{
						key: 'taskStatus',
						label: '任务状态',
						value: MODULE_TASK_STATUS_MAP[this.taskDetails?.taskStatus],
					},
					{
						key: 'waitCount',
						label: '前方排队',
						value: this.taskDetails?.waitCount,
					},
					{
						key: 'importTotal',
						label: '导入总数',
						value: this.taskDetails?.importTotal,
					},
					{
						key: 'pendingCount',
						label: '待执行数',
						value: this.taskDetails?.pendingCount,
					},
					{
						key: 'successCount',
						label: '成功数',
						value: this.taskDetails?.successCount,
					},
					{
						key: 'failureCount',
						label: '失败数',
						value: this.taskDetails?.failureCount,
					},
					{
						key: 'createStaffName',
						label: '创建人',
						value: this.taskDetails?.createStaffName,
					},
					{
						key: 'createTime',
						label: '创建时间',
						value: this.taskDetails?.createTime,
					},
					this.taskDetails?.failureCount
						? {
								key: 'failFilePath',
								label: '失败数据明细',
								value: '导出失败明细',
								slot: 'failFilePath',
						  }
						: null,
					{
						key: 'remark',
						label: '备注',
						value: this.taskDetails?.remark,
						col: 4,
					},
				].filter(Boolean),
			}
		},
	},
}
</script>

<style lang="scss" scoped>
@import '../../run-manage/runLayout.scss';
.task-details-main {
	flex-direction: column;
	padding: 0 20px;
	.task-details-table-show {
		flex: 1;
		display: flex;
		flex-direction: column;
		height: 0;
		.table-header {
			font-size: 17px;
			font-weight: 600;
			color: #333333;
			padding-bottom: 20px;
		}
		.table-box {
			flex: 1;
			height: 0;
			display: flex;
			flex-direction: column;
			.serach {
				display: flex;
				flex-wrap: wrap;
				.serach-ops {
					::v-deep .el-button {
						border-radius: 8px;
					}
				}
				& > div {
					margin-right: 12px;
					margin-bottom: 8px;
				}
				.export-ops {
					margin-left: auto;
					margin-right: 0;
				}
			}
			::v-deep .gc-table {
				flex: 1;
				height: 0;
				margin-top: 8px;
			}
		}
	}
}
::v-deep .desc {
	.el-textarea.is-disabled .el-textarea__inner {
		border: 1px solid #d9d9d9;
		background: #ffffff !important;
		color: #4e4e4e;
	}
}

.download-file-path {
	color: #4d6bff;
	cursor: pointer;
	display: inline-block;
}
</style>
